const getUserConsentKey = () => {
  return `user-consent-hpc`
}

export default getUserConsentKey
